import React from 'react';

const Share = () => {
    return (
        <svg
            width='33'
            height='32'
            viewBox='0 0 33 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            {/* <circle cx="16.5" cy="16" r="16" fill="#696969" fillOpacity="0.6" /> */}
            <path
                d='M27 15L18.8333 6.83333V11.5C10.6667 12.6667 7.16667 18.5 6 24.3333C8.91667 20.25 13 18.3833 18.8333 18.3833V23.1667L27 15Z'
                fill='#696969'
            />
        </svg>
    );
};

export default Share;
